import React from "react";
import Header from "../pages/Header";
import Footer from "../pages/Footer";
import { makeStyles } from "@material-ui/core/styles";
import EventLogin from "../components/EventLogin";
const useStyles = makeStyles({
  root: {
    height: "100%",
    width: "100%",
    marginLeft: "auto",
    marginRight: "auto",
    paddingLeft: 10,
    paddingRight: 10,
  },
  bodyBox: {
    width: "100%",
    height: "74%",
    paddingBottom: "5%",
    paddingTop: "5%",
  },
  "@media screen and (min-width:600px)": {
    root: {
      maxWidth: 600,
      paddingLeft: "1%",
      paddingRight: "1%",
    },
  },
});
function EventLoginContainer() {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <Header title="로그인 화면" />
      <div className={classes.bodyBox}>
        <EventLogin />
      </div>
      <Footer />
    </div>
  );
}
export default EventLoginContainer;
